// extracted by mini-css-extract-plugin
export default {"main":"AdminGoalPip_main__2gxCc","heads":"AdminGoalPip_heads__r2DXC"};